var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 7954"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.6383 5.55078C4.31772 5.55078 4.05859 5.75809 4.05859 6.01455V9.72469C4.05859 9.98116 4.31772 10.1885 4.6383 10.1885C4.95888 10.1885 5.21801 9.98116 5.21801 9.72469V6.01455C5.21801 5.75809 4.95888 5.55078 4.6383 5.55078Z",
    fill: "#F04A00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.53674 5.55078C7.21616 5.55078 6.95703 5.75809 6.95703 6.01455V9.72469C6.95703 9.98116 7.21616 10.1885 7.53674 10.1885C7.85732 10.1885 8.11645 9.98116 8.11645 9.72469V6.01455C8.11645 5.75809 7.85732 5.55078 7.53674 5.55078Z",
    fill: "#F04A00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.6087 0.333496H4.56522C4.00572 0.333496 3.55072 0.793496 3.55072 1.35914V2.38478H2.02899H0.507246C0.226739 2.38478 0 2.61401 0 2.8976C0 3.18119 0.226739 3.41042 0.507246 3.41042H1.52174V12.1284C1.52174 12.9766 2.20449 13.6668 3.04348 13.6668H9.13043C9.96942 13.6668 10.6522 12.9766 10.6522 12.1284V3.41042H11.6667C11.9472 3.41042 12.1739 3.18119 12.1739 2.8976C12.1739 2.61401 11.9472 2.38478 11.6667 2.38478H10.1449H8.62319V1.35914C8.62319 0.793496 8.16819 0.333496 7.6087 0.333496ZM9.63768 12.1284C9.63768 12.4114 9.41043 12.6412 9.13043 12.6412H3.04348C2.76348 12.6412 2.53623 12.4114 2.53623 12.1284V3.41042H9.63768V12.1284ZM4.56522 2.38478V1.35914H7.6087V2.38478H4.56522Z",
    fill: "#F04A00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete);
export default __webpack_public_path__ + "static/media/ic-delete.d9d4d9f0a447dfe2d9829ee65f0edc36.svg";
export { ForwardRef as ReactComponent };